import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import cartConfig from "emun.cart/cart.config";
// import moment from "moment";
import AutoQuery from "servicestack/auto-query/auto-query";
import OrderEnterCreditcard from "emun.order/order-enter-creditcard";

export default class RetrieveHostedPCIInfoController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		$ctrl.cartConfig = cartConfig;
		console.debug("BL*** options", options);
    $ctrl.token = options.token;
	$ctrl.tokenizationCode = options.tokenizationCode;
	$ctrl.expiration = options.expiration;
    $ctrl.cvv = options.cvv;
	$ctrl.type = options.type;
	$ctrl.name = options.name;
	$ctrl.lastFour = options.lastFour;
		$ctrl.title = options.title || "Token Information";
	}
	$onInit() {
		const $ctrl = this;
	}

}
